// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__22jFb","author":"Table_author__2WZUa","authorImage":"Table_authorImage__HOaTP","unreadRow":"Table_unreadRow__2efL_"};